import { type User } from "@overmap-ai/common"
import { selectUsers } from "@overmap-ai/core"
import { ReactRenderer } from "@tiptap/react"

import { appStore } from "../../../../store"
import type { MentionListRef, MentionListRootProps } from "../../../blocks"
import { UserMentionList } from "../../../components"
import type { SuggestionOptions } from "../typings"
import { updatePosition } from "../utils"

export const suggestion: SuggestionOptions<User> = {
	char: "@u",
	items: ({ query }) => {
		// TODO: scope this based on org or project
		const users = selectUsers(appStore.getState())

		return users
			.filter((user) => {
				const searchString = (user.email || "").toLowerCase()
				return searchString.startsWith(query.toLowerCase())
			})
			.slice(0, 10)
	},

	render: () => {
		let component: ReactRenderer<MentionListRef<User>, MentionListRootProps<User>>

		return {
			onStart: (props) => {
				component = new ReactRenderer(UserMentionList, {
					props,
					editor: props.editor,
					as: "div",
				})

				if (!props.clientRect) {
					return
				}

				;(component.element as HTMLElement).style.position = "fixed"
				component.element.setAttribute("data-floating-content", "")

				document.body.appendChild(component.element)

				updatePosition(props.editor, component.element as HTMLElement)
			},

			onUpdate(props) {
				component.updateProps(props)

				if (!props.clientRect) {
					return
				}

				updatePosition(props.editor, component.element as HTMLElement)
			},

			onKeyDown(props) {
				if (props.event.key === "Escape") {
					component.destroy()

					return true
				}

				return component.ref?.onKeyDown?.(props) ?? false
			},

			onExit() {
				component.element.remove()
				component.destroy()
			},
		}
	},
}
